import { Dispatch, SetStateAction } from "react";
import { AsyncSelect } from "shared/components/AsyncSelect/AsyncSelect";
import { Button, ButtonVariant } from "shared/components/Button";
import { Stepper } from "../components/Stepper";
import { loadPropertyOptions, loadUnitOptions } from "../api";
import { Header } from "../components/Header";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
export const ChooseProperty = ({
  setOpen,
  setSelectedPropertyId,
  setSelectedUnitId,
  selectedPropertyId,
  selectedUnitId,
  setStepIdx,
  propertyName,
  unitName
}: {
  setOpen: (open: boolean) => void;
  setSelectedPropertyId: Dispatch<SetStateAction<number | undefined>>;
  setSelectedUnitId: Dispatch<SetStateAction<number | undefined>>;
  selectedPropertyId: number | undefined;
  selectedUnitId: number | undefined;
  setStepIdx: Dispatch<SetStateAction<number>>;
  propertyName?: string;
  unitName?: string;
}) => {
  const dictionary = useUnitsPropertiesDictionary();

  return (
    <>
      <Header
        title={`Select ${dictionary.unit}`}
        description={`Select a ${dictionary.unit} for which you want to create an application`}
        onClose={() => setOpen(false)}
      />

      <div className="p-6 border-b border-alpha-40">
        <Stepper currentStepIdx={0} totalSteps={2} />
      </div>

      <div className="flex p-6 gap-4">
        <div className="w-full">
          <AsyncSelect
            id="property"
            disabled={Boolean(propertyName)}
            label={dictionary.Property}
            value={selectedPropertyId || ""}
            menuPortalTarget={document.body}
            searchable={true}
            menuPosition="fixed"
            menuPlacement="auto"
            hideOptional
            // @ts-expect-error -- TODO: fix this
            loadOptions={loadPropertyOptions}
            options={
              propertyName && selectedPropertyId
                ? [
                    {
                      label: propertyName,
                      value: selectedPropertyId
                    }
                  ]
                : []
            }
            onChange={(e) => {
              if (!Array.isArray(e)) {
                setSelectedPropertyId(Number(e.target.value));
                setSelectedUnitId(undefined);
              }
            }}
            additional={{
              page: 1
            }}
          />
        </div>
        <div className="w-full">
          <AsyncSelect
            id="unit"
            label={dictionary.Unit}
            key={selectedPropertyId}
            searchable={true}
            hideOptional
            disabled={Boolean(unitName)}
            value={selectedUnitId || ""}
            menuPortalTarget={document.body}
            menuPosition="absolute"
            menuPlacement="bottom"
            options={
              unitName && selectedUnitId
                ? [
                    {
                      label: unitName,
                      value: selectedUnitId
                    }
                  ]
                : []
            }
            // @ts-expect-error -- TODO: fix this
            loadOptions={loadUnitOptions}
            additional={{ page: 1, propertyId: selectedPropertyId }}
            onChange={(e) => {
              if (!Array.isArray(e)) setSelectedUnitId(Number(e.target.value));
            }}
          />
        </div>
      </div>

      <div className="flex justify-end p-6 mt-auto border-t border-alpha-40">
        <Button
          variant={ButtonVariant.PRIMARY}
          disabled={!selectedPropertyId || !selectedUnitId}
          tooltip={
            selectedPropertyId && selectedUnitId
              ? undefined
              : !selectedPropertyId
                ? `Please select a ${dictionary.property}`
                : `Please select a ${dictionary.unit}`
          }
          tooltipZIndex={50}
          onClick={() => setStepIdx(1)}
        >
          Continue
        </Button>
      </div>
    </>
  );
};
